import React from 'react';
import RoadmapTimeline from './components/RoadmapTimeline';

export default function DevSecAIRoadmapDisplay({ roadmap, maxMonth, isUnlocked, roleKey }) {
  return (
    <RoadmapTimeline
      roadmap={roadmap}
      title={`Your ${roadmap?.totalMonths || 6}-Month DevSecAI Career Roadmap`}
      subtitle="DevSecOps & AI Security Journey"
      maxMonth={maxMonth}
      isUnlocked={isUnlocked}
      fileName="tekyu-devsecai-roadmap.pdf"
      roleKey={roleKey || "devsecai"}
    />
  );
}